var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c(
            "card-header",
            { attrs: { title: _vm.$router.currentRoute.meta.title } },
            [
              !_vm.serverError
                ? _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "can",
                          rawName: "v-can:edit",
                          value: _vm.permissionPrefix,
                          expression: "permissionPrefix",
                          arg: "edit"
                        }
                      ],
                      staticClass: "btn btn-primary btn-sm",
                      attrs: {
                        to: {
                          name: _vm.routePrefix + ".edit",
                          params: { id: _vm.id }
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-edit" })]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm.serverError
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                      ]),
                      _vm._v(" " + _vm._s(_vm.serverError) + " ")
                    ])
                  : _vm._e()
              ])
            ]),
            !_vm.serverError
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "perTask",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "per_task",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.perTask,
                        callback: function($$v) {
                          _vm.perTask = $$v
                        },
                        expression: "perTask"
                      }
                    }),
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "kmStartAfter",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "km_start_after",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.kmStartAfter,
                        callback: function($$v) {
                          _vm.kmStartAfter = $$v
                        },
                        expression: "kmStartAfter"
                      }
                    }),
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "perKm",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "per_km",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.perKm,
                        callback: function($$v) {
                          _vm.perKm = $$v
                        },
                        expression: "perKm"
                      }
                    }),
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "maxOrderAmount",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "max_order_amount",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.maxOrderAmount,
                        callback: function($$v) {
                          _vm.maxOrderAmount = $$v
                        },
                        expression: "maxOrderAmount"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "card-footer" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-neutral btn-sm",
                      attrs: { to: { name: "suppliers.index" } }
                    },
                    [_c("i", { staticClass: "fa fa-arrow-left" })]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }